/*
 * @Description: 页面名称
 * @Autor: kangcheng
 * @Date: 2024-01-04 13:56:44
 * @LastEditors: kangcheng
 * @LastEditTime: 2024-01-11 15:12:19
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import VConsole from 'vconsole';
import '@/vantui';
import { Image as VanImage } from 'vant';
Vue.use(VanImage);
import 'reset-css';
import "@/style/common.less"

// Vue.prototype.$confirm = 


Vue.config.productionTip = false;
// const vConsole = new VConsole();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
